module.exports = __webpack_public_path__ + "static/media/knoppix.7383e6da.jpg";